import * as React from 'react';

var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgInputError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-class": "InputError-stroke",
    stroke: "#D0021B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.466 2.527c.817-1.437 2.147-1.426 2.957 0l10.154 17.87c.817 1.438.142 2.603-1.53 2.603H2.843c-1.661 0-2.34-1.176-1.53-2.602l10.154-17.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7v9m0 2.419V20",
    strokeLinecap: "round"
  }))));
}

export { SvgInputError as S };
